import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=5847d7ee&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5847d7ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5847d7ee')) {
      api.createRecord('5847d7ee', component.options)
    } else {
      api.reload('5847d7ee', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=5847d7ee&scoped=true&", function () {
      api.rerender('5847d7ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O3w47xxe97Od/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports